import {
	DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
} from '../../entities';
import { NounSubtypeKey, TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { NotionIcon } from './icon';
import { NotionIconBorderless } from './icon-borderless';
import { NotionSearchResultIcon } from './search-result-icon';

export const notionConfig: ThirdPartyConfig = {
	displayName: 'Notion',
	id: 'notion',
	resourceType: 'notion-connector',
	icon: get3PLogo(NotionIcon, 'Notion', 'medium'),
	iconBorderless: get3PLogo(NotionIconBorderless, 'Notion', 'small'),
	searchResultIcon: get3PLogo(NotionSearchResultIcon, 'Notion', 'large'),
	integrationAri: 'ari:cloud:platform::integration/notion',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				],
				subTypes3P: [NounSubtypeKey.Document],
			},
		],
	]),
	filters: ['lastUpdated', 'onlyTitleMatch'],
	requiresOauth: true,
	isEnabled: () => true,
};
